export const firebaseConfig = {
  apiKey: "AIzaSyD0Q0mItrWDu2OPXB-b8YUwTA5yggt6i8E",
  authDomain: "donotforgetme-010.firebaseapp.com",
  projectId: "donotforgetme-010",
  storageBucket: "donotforgetme-010.appspot.com",
  messagingSenderId: "131032458649",
  appId: "1:131032458649:web:9b682c9e58103d58839f08",
  measurementId: "G-0LTYGMPCKF",
};
